import SuccessBanner from "../SuccessBanner";
import withTouchOutsideDismissible from "../../common/WithTouchOutsideDismissible";
import classnames from "classnames";
import styles from "./index.css";

const className = classnames(styles.successBanner, styles.show);

export default withTouchOutsideDismissible({
  component: SuccessBanner,
  className,
  shouldRenderKey: "successMessage"
});
